/* ------------------------------------------------------------------ */
/*  PET Can Europe – PceCan3D                                          */
/*  3D can preview with sticker / silk-print projection.               */
/*                                                                     */
/*  The can is rebuilt at runtime from the exact lathe profiles of the */
/*  supplied model (Ø 64.8 mm · 114.9 mm high · shoulder at 100.2 mm,  */
/*  aluminium easy-open lid). Units inside the scene are metres, Y up, */
/*  base at the origin.                                                */
/*                                                                     */
/*  Usage:                                                             */
/*    const v = PceCan3D.create(canvasEl, { lid: true, view: 'hero' });*/
/*    v.setDecal({ image, widthMm: 60, heightMm: 40, shape: 'rect',   */
/*                 background: 'white', centerMm: 55 });               */
/* ------------------------------------------------------------------ */
import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.170.0/+esm';
import { OrbitControls } from 'https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/controls/OrbitControls.js/+esm';
const MODEL = {"v":1,"units":"mm","dims":{"height":114.9,"diameter":64.8,"lipDiameter":56.6,"shoulder":100.2,"lidHeight":116.4},"materials":{"pet":{"type":"physical","color":[0.96,0.972,0.985],"opacity":0.28,"metalness":0.08,"roughness":0.085,"ior":1.57,"clearcoat":1,"clearcoatRoughness":0.065},"petBottom":{"type":"physical","color":[0.96,0.972,0.985],"opacity":0.42,"metalness":0.08,"roughness":0.18,"ior":1.57,"clearcoat":1,"clearcoatRoughness":0.065},"aluBrushed":{"type":"standard","color":[0.79,0.805,0.82],"metalness":1,"roughness":0.28},"aluPolished":{"type":"standard","color":[0.79,0.805,0.82],"metalness":1,"roughness":0.2},"groove":{"type":"standard","color":[0.4,0.43,0.46],"metalness":1,"roughness":0.35}},"parts":[{"n":"body","t":"lathe","m":"pet","p":[[0.0,5.25],[2.4,5.25],[3.024,5.197],[3.393,5.093],[3.65,5.02],[3.87,5.137],[4.056,5.434],[4.29,5.781],[4.65,6.05],[5.09,6.203],[5.619,6.225],[6.176,6.134],[6.7,5.95],[7.962,5.287],[9.737,4.518],[11.891,3.769],[14.29,3.162],[16.8,3.37],[19.393,3.19],[21.719,3.09],[23.698,2.463],[25.25,2.35],[25.708,2.043],[26.094,1.48],[26.456,0.834],[26.842,0.283],[27.3,0.0],[28.0,0.0],[28.566,0.16],[29.069,0.584],[29.519,1.188],[29.926,1.888],[30.3,2.6],[30.979,3.865],[31.558,5.158],[32.006,6.51],[32.297,7.947],[32.4,9.5],[32.4,100.2],[32.379,100.64],[32.314,101.047],[32.2,101.4],[31.655,102.439],[30.859,103.615],[29.944,104.863],[29.041,106.119],[28.282,107.319],[27.8,108.4],[27.624,109.109],[27.559,109.674],[27.55,110.15],[27.55,112.55],[27.615,112.68],[27.735,112.794],[27.8,112.93],[27.735,113.081],[27.615,113.212],[27.55,113.35],[27.55,114.15],[27.667,114.269],[27.925,114.35],[28.183,114.431],[28.3,114.55],[28.267,114.73],[28.173,114.854],[28.02,114.9],[27.34,114.9],[27.226,114.868],[27.161,114.779],[27.14,114.64],[27.14,110.12],[27.164,109.332],[27.25,108.708],[27.42,108.1],[27.932,106.985],[28.702,105.78],[29.601,104.544],[30.501,103.337],[31.274,102.219],[31.79,101.25],[31.892,100.902],[31.945,100.568],[31.96,100.2],[31.96,9.6],[31.865,8.17],[31.592,6.872],[31.154,5.694],[30.569,4.624],[29.85,3.65],[29.28,2.876],[28.7,2.144],[28.12,1.59],[27.55,1.35],[27.094,1.607],[26.712,2.24],[26.313,2.933],[25.8,3.37],[23.959,3.571],[21.8,4.219],[19.416,4.307],[16.9,4.48],[14.408,4.27],[12.06,4.873],[9.988,5.598],[8.324,6.303],[7.2,6.85],[6.259,7.205],[5.225,7.287],[4.303,7.089],[3.7,6.6],[3.398,6.308],[3.088,6.25],[2.758,6.305],[2.4,6.35],[0.0,6.35]]},{"n":"lid","t":"lathe","m":"aluBrushed","p":[[0.0,112.94],[21.35,112.94],[22.4,113.0],[24.15,112.91],[24.493,112.835],[24.824,112.695],[25.18,112.62],[25.565,112.62],[25.868,112.7],[26.1,112.92],[27.32,115.41],[27.625,115.631],[28.032,115.687],[28.414,115.612],[28.64,115.44],[28.599,115.161],[28.398,114.913],[28.13,114.74],[28.13,112.34],[28.35,112.34],[28.596,112.404],[28.76,112.606],[28.82,112.93],[28.83,114.66],[29.007,114.823],[29.2,115.018],[29.356,115.276],[29.42,115.63],[29.329,115.894],[29.088,116.108],[28.742,116.267],[28.337,116.366],[27.92,116.4],[27.521,116.305],[27.176,116.131],[26.884,115.877],[26.642,115.547],[26.45,115.14],[25.82,113.4],[25.695,113.115],[25.512,112.952],[25.26,112.9],[25.038,112.948],[24.832,113.049],[24.55,113.11],[24.261,113.166],[24.006,113.248],[23.65,113.29],[22.3,113.29],[22.044,113.267],[21.789,113.223],[21.4,113.2],[0.0,113.2]]},{"n":"seam","t":"lathe","m":"aluPolished","p":[[28.945,113.17],[28.926,113.124],[28.88,113.105],[28.834,113.124],[28.815,113.17],[28.834,113.216],[28.88,113.235],[28.926,113.216],[28.945,113.17]]},{"n":"groove","t":"lathe","m":"groove","p":[[23.845,113.3],[23.832,113.268],[23.8,113.255],[23.768,113.268],[23.755,113.3],[23.768,113.332],[23.8,113.345],[23.832,113.332],[23.845,113.3]]},{"n":"ring","t":"lathe","m":"aluPolished","p":[[22.272,113.3],[22.26,113.27],[22.23,113.258],[22.2,113.27],[22.188,113.3],[22.2,113.33],[22.23,113.342],[22.26,113.33],[22.272,113.3]]}]};

function PceCan3DFactory(THREE, OrbitControls) {
  var CAN = { height: 114.9, radius: 32.4, shoulder: 100.2, bandMin: 12, bandMax: 96 };
  var MM = 0.001;
  var LID_PARTS = { lid: 1, seam: 1, groove: 1, ring: 1, tab: 1, tabEdge: 1, rivet: 1, tabDetail: 1 };

  /* ---------- geometry from the compact model ---------- */
  function b64ToBytes(s) { var bin = atob(s), u = new Uint8Array(bin.length); for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i); return u; }

  function latheGeometry(profile, segments) {
    var pos = [], uv = [], idx = [], n = profile.length;
    for (var s = 0; s <= segments; s++) {
      var a = s / segments * Math.PI * 2, sa = Math.sin(a), ca = Math.cos(a);
      for (var i = 0; i < n; i++) {
        var r = profile[i][0] * MM, y = profile[i][1] * MM;
        pos.push(r * sa, y, r * ca); uv.push(s / segments, i / (n - 1));
      }
    }
    for (var s2 = 0; s2 < segments; s2++) for (var i2 = 0; i2 < n - 1; i2++) {
      var a0 = s2 * n + i2, b0 = a0 + n, c0 = a0 + 1, d0 = b0 + 1;
      idx.push(a0, b0, c0, b0, d0, c0);
    }
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    g.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
    g.setIndex(idx);
    g.computeVertexNormals();
    // make sure the outer surface faces outward: test the widest vertex
    var p = g.attributes.position, nrm = g.attributes.normal, best = -1, bi = 0;
    for (var k = 0; k < n; k++) { var rr = profile[k][0]; if (rr > best) { best = rr; bi = k; } }
    var dot = p.getX(bi) * nrm.getX(bi) + p.getZ(bi) * nrm.getZ(bi);
    if (dot < 0) { var id = g.index.array; for (var t = 0; t < id.length; t += 3) { var tmp = id[t + 1]; id[t + 1] = id[t + 2]; id[t + 2] = tmp; } g.index.needsUpdate = true; g.computeVertexNormals(); }
    return g;
  }

  function meshGeometry(part) {
    var q = new Int16Array(b64ToBytes(part.pos).buffer), tri = new Uint16Array(b64ToBytes(part.idx).buffer);
    var pos = new Float32Array(q.length);
    for (var i = 0; i < q.length; i += 3) {
      pos[i] = (part.o[0] + q[i] * part.q) * MM; pos[i + 1] = (part.o[1] + q[i + 1] * part.q) * MM; pos[i + 2] = (part.o[2] + q[i + 2] * part.q) * MM;
    }
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    g.setIndex(new THREE.BufferAttribute(tri, 1));
    g.computeVertexNormals();
    return g;
  }

  function material(name) {
    var m = MODEL.materials[name], c = new THREE.Color(m.color[0], m.color[1], m.color[2]);
    if (m.type === 'physical') {
      return new THREE.MeshPhysicalMaterial({ color: c, transparent: true, opacity: m.opacity, metalness: m.metalness, roughness: m.roughness, ior: m.ior, clearcoat: m.clearcoat, clearcoatRoughness: m.clearcoatRoughness, side: THREE.FrontSide, envMapIntensity: 1 });
    }
    return new THREE.MeshStandardMaterial({ color: c, metalness: m.metalness, roughness: m.roughness, envMapIntensity: 1 });
  }

  var geoCache = {};
  function addPart(group, part, segments) {
    var key = part.n + ':' + segments;
    if (!geoCache[key]) geoCache[key] = part.t === 'lathe' ? latheGeometry(part.p, segments) : meshGeometry(part);
    var mesh = new THREE.Mesh(geoCache[key], material(part.m));
    mesh.name = part.n;
    group.add(mesh);
  }
  function buildCan(withLid, segments) {
    var group = new THREE.Group(); group.name = withLid ? 'can-closed' : 'can-open';
    group.userData.lid = withLid;
    MODEL.parts.forEach(function (part) { if (withLid || !LID_PARTS[part.n]) addPart(group, part, segments); });
    if (withLid) DETAILS.parts.forEach(function (part) { addPart(group, part, segments); });
    return group;
  }
  /* The pull-tab details (free-form meshes) live in a separate asset so the
     engine stays small; the can renders without them if that file is missing. */
  var DETAILS = { parts: [] }, detailWaiters = [];
  (function loadDetails() {
    var url = window.PCE_CAN_DETAILS_URL;
    if (!url || !window.fetch) return;
    fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.parts) return;
      DETAILS = j;
      detailWaiters.forEach(function (fn) { fn(); }); detailWaiters = [];
    }).catch(function () {});
  })();

  /* ---------- studio environment ---------- */
  function environment(renderer) {
    var pmrem = new THREE.PMREMGenerator(renderer), env = new THREE.Scene();
    env.add(new THREE.Mesh(new THREE.BoxGeometry(12, 12, 12), new THREE.MeshBasicMaterial({ color: new THREE.Color(.08, .08, .08), side: THREE.BackSide })));
    function light(x, y, z, w, h, b) {
      var m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(b, b, b), side: THREE.DoubleSide }));
      m.position.set(x, y, z); m.lookAt(0, 0, 0); env.add(m);
    }
    light(-3.8, 1, 2.2, 1.6, 6.5, 6.5); light(4.5, .6, 1.5, .7, 6, 5); light(-1, 2, -4, 2.8, 4.5, 3.5);
    light(0, 5, 0, 3, 3, 2.5); light(1, -3, -1, 3, 3, .6);
    var tex = pmrem.fromScene(env, .015).texture;
    env.traverse(function (o) { if (o.isMesh) { o.geometry.dispose(); o.material.dispose(); } });
    pmrem.dispose();
    return tex;
  }

  function shadowPlane() {
    var c = document.createElement('canvas'); c.width = c.height = 256;
    var ctx = c.getContext('2d'), g = ctx.createRadialGradient(128, 128, 10, 128, 128, 128);
    g.addColorStop(0, 'rgba(30,35,36,0.16)'); g.addColorStop(.5, 'rgba(30,35,36,0.08)'); g.addColorStop(1, 'rgba(30,35,36,0)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, 256, 256);
    var m = new THREE.Mesh(new THREE.PlaneGeometry(.118, .118), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(c), transparent: true, depthWrite: false }));
    m.rotation.x = -Math.PI / 2; m.position.y = -5e-4; return m;
  }

  /* ---------- decal ---------- */
  function bentPlane(width, height, radius, rot) {
    var segs = Math.max(24, Math.min(160, Math.round(width / radius * 40)));
    var g = new THREE.PlaneGeometry(width, height, segs, 2), p = g.attributes.position;
    var c = Math.cos(rot || 0), s = Math.sin(rot || 0);
    for (var i = 0; i < p.count; i++) {
      var x = p.getX(i), y = p.getY(i), rx = x * c - y * s, ry = x * s + y * c, a = rx / radius;
      p.setXYZ(i, radius * Math.sin(a), ry, radius * Math.cos(a));
    }
    p.needsUpdate = true; g.computeVertexNormals(); return g;
  }

  function roundedRect(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }
  function drawContain(ctx, img, x, y, w, h) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var k = Math.min(w / iw, h / ih), dw = iw * k, dh = ih * k;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }

  function decalCanvas(spec) {
    var scale = Math.min(20, 2048 / spec.widthMm);
    var W = Math.max(64, Math.round(spec.widthMm * scale)), H = Math.max(64, Math.round(spec.heightMm * scale));
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d'); ctx.clearRect(0, 0, W, H);
    var shape = spec.shape || 'none', white = spec.background === 'white', pad = 0;
    if (shape !== 'none') {
      if (shape === 'round') { ctx.beginPath(); ctx.ellipse(W / 2, H / 2, W / 2 - 1, H / 2 - 1, 0, 0, Math.PI * 2); ctx.closePath(); }
      else roundedRect(ctx, 1, 1, W - 2, H - 2, (spec.cornerMm || 2.5) * scale);
      if (white) { ctx.fillStyle = '#ffffff'; ctx.fill(); }
      else { ctx.fillStyle = 'rgba(255,255,255,0.07)'; ctx.fill(); ctx.strokeStyle = 'rgba(255,255,255,0.35)'; ctx.lineWidth = Math.max(1, scale * .15); ctx.stroke(); }
      ctx.save(); ctx.clip();
      pad = Math.round(Math.min(W, H) * (shape === 'round' ? 0.14 : 0.09));
    }
    if (spec.image) {
      if (spec.layout === 'repeat') {
        var n = spec.repeat || 3, cw = W / n;
        for (var i = 0; i < n; i++) drawContain(ctx, spec.image, i * cw + cw * .12, H * .08, cw * .76, H * .84);
      } else if (spec.layout === 'wrap') {
        ctx.drawImage(spec.image, 0, 0, W, H);
      } else {
        drawContain(ctx, spec.image, pad, pad, W - pad * 2, H - pad * 2);
      }
    } else if (spec.placeholder !== false) {
      ctx.fillStyle = 'rgba(20,24,29,0.38)';
      ctx.font = '600 ' + Math.round(Math.min(W, H) * 0.11) + 'px Helvetica, Arial, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText(spec.placeholderText || 'Your logo', W / 2, H / 2);
      if (shape === 'none') {
        ctx.setLineDash([scale * 1.2, scale * 1.2]); ctx.strokeStyle = 'rgba(20,24,29,0.35)'; ctx.lineWidth = Math.max(1, scale * .12);
        ctx.strokeRect(scale, scale, W - scale * 2, H - scale * 2);
      }
    }
    if (shape !== 'none') ctx.restore();
    return c;
  }

  /* ---------- viewer ---------- */
  function Viewer(canvas, opts) {
    opts = opts || {};
    var self = this;
    this.canvas = canvas; this.opts = opts; this.listeners = {}; this.decal = null; this.decalSpec = null;
    var r = this.renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: false, preserveDrawingBuffer: true });
    r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    r.outputColorSpace = THREE.SRGBColorSpace; r.toneMapping = THREE.ACESFilmicToneMapping; r.toneMappingExposure = 1.1;
    var scene = this.scene = new THREE.Scene();
    scene.background = new THREE.Color(opts.background || '#f4f6f8');
    var cam = this.camera = new THREE.PerspectiveCamera(30, 1, .005, 10);
    var ctl = this.controls = new OrbitControls(cam, canvas);
    ctl.enableDamping = true; ctl.dampingFactor = .1; ctl.minDistance = .09; ctl.maxDistance = .55;
    ctl.enablePan = false; ctl.enableZoom = opts.zoom === true; ctl.autoRotateSpeed = 1.2; ctl.maxPolarAngle = Math.PI * .72;
    scene.environment = environment(r);
    this.shadow = shadowPlane(); scene.add(this.shadow);
    this.segments = opts.segments || 96;
    this.cans = {};
    this.setLid(opts.lid !== false);
    detailWaiters.push(function () {
      var closed = self.cans.closed; if (!closed) return;
      var have = {}; closed.children.forEach(function (m) { have[m.name] = 1; });
      DETAILS.parts.forEach(function (part) { if (!have[part.n]) addPart(closed, part, self.segments); });
    });
    this.view(opts.view || 'hero');

    var host = canvas.parentElement || canvas;
    function fit() {
      var b = host.getBoundingClientRect(); if (!b.width || !b.height) return;
      r.setSize(b.width, b.height, false); cam.aspect = b.width / b.height; cam.updateProjectionMatrix();
    }
    if (window.ResizeObserver) new ResizeObserver(fit).observe(host); else window.addEventListener('resize', fit);
    fit();
    var running = true;
    function tick() { if (!running) return; requestAnimationFrame(tick); ctl.update(); self.shadow.visible = cam.position.y > .004; r.render(scene, cam); }
    tick();
    this._stop = function () { running = false; };
    this.ready = true;
    setTimeout(function () { self.emit('ready'); }, 0);
  }

  Viewer.prototype.on = function (ev, fn) { (this.listeners[ev] = this.listeners[ev] || []).push(fn); return this; };
  Viewer.prototype.emit = function (ev, arg) { (this.listeners[ev] || []).forEach(function (f) { f(arg); }); };

  Viewer.prototype.setLid = function (on) {
    var key = on ? 'closed' : 'open', self = this;
    if (!this.cans[key]) { this.cans[key] = buildCan(on, this.segments); this.scene.add(this.cans[key]); }
    Object.keys(this.cans).forEach(function (k) { self.cans[k].visible = k === key; });
    this.lid = !!on; this.emit('lid', this.lid);
  };

  Viewer.prototype.view = function (name) {
    var c = this.camera, t = this.controls; t.autoRotate = false;
    if (name === 'front') { c.position.set(0, .085, .275); t.target.set(0, .056, 0); }
    else if (name === 'top') { c.position.set(.025, .285, .11); t.target.set(0, .08, 0); }
    else if (name === 'back') { c.position.set(.02, .085, -.275); t.target.set(0, .056, 0); }
    else if (name === 'side') { c.position.set(.27, .09, .06); t.target.set(0, .056, 0); }
    else { c.position.set(.11, .14, .25); t.target.set(0, .057, 0); }
    t.update(); this.emit('view', name);
  };
  Viewer.prototype.autoRotate = function (on) { this.controls.autoRotate = !!on; return this.controls.autoRotate; };
  Viewer.prototype.zoom = function (factor) {
    var c = this.camera, t = this.controls, d = c.position.clone().sub(t.target), len = d.length() * factor;
    len = Math.max(t.minDistance, Math.min(t.maxDistance, len));
    c.position.copy(t.target).add(d.normalize().multiplyScalar(len)); t.update();
  };
  Viewer.prototype.setBackground = function (hex) { this.scene.background = new THREE.Color(hex); };

  /*
    spec: image (HTMLImageElement|null), widthMm, heightMm, shape 'round'|'square'|'rect'|'none',
          background 'white'|'transparent', centerMm, rotationDeg, layout 'single'|'repeat'|'wrap',
          repeat (copies), angleDeg (0 = front), finish 'sticker'|'ink', placeholderText
  */
  Viewer.prototype.setDecal = function (spec) {
    if (this.decal) { this.scene.remove(this.decal); this.decal.geometry.dispose(); if (this.decal.material.map) this.decal.material.map.dispose(); this.decal.material.dispose(); this.decal = null; }
    this.decalSpec = spec;
    if (!spec) return null;
    var radius = (CAN.radius + 0.18) * MM, circ = 2 * Math.PI * CAN.radius;
    var w = spec.widthMm, h = spec.heightMm;
    if (spec.layout === 'wrap' || spec.layout === 'repeat') w = circ;
    w = Math.min(w, circ); h = Math.min(h, CAN.bandMax - CAN.bandMin);
    var top = Math.min(CAN.bandMax, spec.centerMm + h / 2), bottom = Math.max(CAN.bandMin, top - h);
    top = bottom + h; if (top > CAN.bandMax) { top = CAN.bandMax; bottom = top - h; }
    var centre = (top + bottom) / 2;
    var tex = new THREE.CanvasTexture(decalCanvas({ widthMm: w, heightMm: h, shape: spec.shape, background: spec.background, image: spec.image, layout: spec.layout, repeat: spec.repeat, placeholder: spec.placeholder, placeholderText: spec.placeholderText, cornerMm: spec.cornerMm }));
    tex.colorSpace = THREE.SRGBColorSpace; tex.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
    var ink = spec.finish === 'ink', white = spec.background === 'white';
    var mat = new THREE.MeshStandardMaterial({ map: tex, transparent: true, roughness: ink ? .42 : (white ? .6 : .3), metalness: 0, side: THREE.DoubleSide, envMapIntensity: ink ? .6 : .9,
      emissive: new THREE.Color('#ffffff'), emissiveMap: tex, emissiveIntensity: ink ? .22 : (white ? .38 : .3) });
    var mesh = new THREE.Mesh(bentPlane(w * MM, h * MM, radius, (spec.rotationDeg || 0) * Math.PI / 180), mat);
    mesh.position.y = centre * MM; mesh.rotation.y = (spec.angleDeg || 0) * Math.PI / 180;
    this.decal = mesh; this.scene.add(mesh);
    var info = { top: top, bottom: bottom, centre: centre, widthMm: w, heightMm: h };
    this.emit('decal', info); return info;
  };

  Viewer.prototype.snapshot = function (type) { this.controls.update(); this.renderer.render(this.scene, this.camera); return this.renderer.domElement.toDataURL(type || 'image/png'); };
  Viewer.prototype.dispose = function () { this._stop(); this.renderer.dispose(); };

  return {
    CAN: CAN,
    MODEL: MODEL,
    create: function (canvas, opts) { return new Viewer(canvas, opts); },
    loadImage: function (src) { return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = src; }); }
  };
}

window.PceCan3D = PceCan3DFactory(THREE, OrbitControls);
window.dispatchEvent(new CustomEvent('pce-can-3d-ready'));
